// @ts-strict-ignore
import React from 'react'
import { Typography, TypographyProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'

interface IPageHeaderTitleProps extends Omit<TypographyProps, 'variant'> {
  children: React.ReactNode
}

const PageHeaderTitle: React.FunctionComponent<IPageHeaderTitleProps> = (props: IPageHeaderTitleProps) => {
  const { children, className, ...restProps } = props
  const theme = useTheme()

  return (
    <React.Fragment>
      <Typography variant="h3" className={className} {...restProps}>
        {children} <div id="mobile-sidebar-button-container" style={{ marginTop: theme.spacing(-3), marginBottom: theme.spacing(-3), display: 'inline-block' }} />
      </Typography>
    </React.Fragment>
  )
}

export default PageHeaderTitle
